import { render } from "./CardPCZ.vue?vue&type=template&id=60b6b6e1"
import script from "./CardPCZ.vue?vue&type=script&lang=js"
export * from "./CardPCZ.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/hypergen.be/pcz.hypergen.be/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__